module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Coffee#2-603fc249e44cc016510de8d36f6f8b8f.svg";